import { createTestCaseTypes } from '../../../common/test-case/types';

export const NAMESPACE = 'analytics-test-history-rdc-test-case';
export default createTestCaseTypes(NAMESPACE);
